"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = require("./resources");
function getResourceString(unit, resource) {
    return (resources_1.getResourceUnits(unit).getString(resource) ||
        resources_1.getResourceUnits(unit).getString(resource, 'en'));
}
var Unit = /** @class */ (function () {
    function Unit() {
    }
    Object.defineProperty(Unit.prototype, "AbbreviatedDisplay", {
        get: function () {
            return getResourceString(this.unitType, this.ClassName + ".AbbreviatedDisplay");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "FullDisplay", {
        get: function () {
            return getResourceString(this.unitType, this.ClassName + ".FullDisplay");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "UnitLanguage", {
        get: function () {
            return resources_1.getResourceUnits(this.unitType).getLanguage();
        },
        set: function (language) {
            resources_1.getResourceUnits(this.unitType).setLanguage(language);
        },
        enumerable: true,
        configurable: true
    });
    Unit.prototype.resetUnitLanguage = function () {
        resources_1.getResourceUnits(this.unitType).setLanguage(resources_1.getResourceUnits(this.unitType).getInterfaceLanguage());
    };
    Unit.prototype.toJSON = function () {
        return {
            AbbreviatedDisplay: this.AbbreviatedDisplay,
            ConversionFactor: this.ConversionFactor,
            FullDisplay: this.FullDisplay,
            Name: this.Name
        };
    };
    Unit.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Unit;
}());
exports.Unit = Unit;
